import { render, staticRenderFns } from "./TableDatatableJs.vue?vue&type=template&id=0b0f5b3d&scoped=true&"
import script from "./TableDatatableJs.vue?vue&type=script&lang=js&"
export * from "./TableDatatableJs.vue?vue&type=script&lang=js&"
import style0 from "./TableDatatableJs.vue?vue&type=style&index=0&id=0b0f5b3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f5b3d",
  null
  
)

export default component.exports